import React, { useCallback } from 'react';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import { changeAlignment } from '../commands';
import ToolbarAlignment from './ToolbarAlignment';
export function PrimaryToolbarComponent(_ref) {
  var api = _ref.api,
    editorView = _ref.editorView,
    disabled = _ref.disabled,
    popupsMountPoint = _ref.popupsMountPoint,
    popupsBoundariesElement = _ref.popupsBoundariesElement,
    popupsScrollableElement = _ref.popupsScrollableElement,
    isToolbarReducedSpacing = _ref.isToolbarReducedSpacing;
  var _useSharedPluginState = useSharedPluginState(api, ['alignment']),
    alignmentState = _useSharedPluginState.alignmentState;
  var changeAlignmentCallback = useCallback(function (align) {
    return changeAlignment(align)(editorView.state, editorView.dispatch);
  }, [editorView]);
  return /*#__PURE__*/React.createElement(ToolbarAlignment, {
    pluginState: alignmentState,
    isReducedSpacing: isToolbarReducedSpacing,
    changeAlignment: changeAlignmentCallback,
    disabled: disabled || !alignmentState.isEnabled,
    popupsMountPoint: popupsMountPoint,
    popupsBoundariesElement: popupsBoundariesElement,
    popupsScrollableElement: popupsScrollableElement,
    api: api
  });
}